import { MarketplaceCartWithProductsSchema } from "@redotech/redo-model/recommerce/marketplace-cart";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getCart = unaryRpc({
  name: "getCart" as const,
  input: z.void(),
  output: z.object({ cart: MarketplaceCartWithProductsSchema.nullable() }),
});
